import { BaseTabBarItem, BaseTabBarItemProps } from './BaseTabBarItem';

type Link = {
  /**
   * Sets the URL that the hyperlink points to. If there is no valid URL use "#" for href value to navigate to the top of the page. 
   */
  href: string;
  /**
   * Label of the TabBarLinkItem. For truncated labels this is the content
   * for tooltip text of the Tab.
   */
  label: string;
};
export type TabBarLinkItemProps<K extends string | number> = Link &
  Pick<
    BaseTabBarItemProps<K>,
    'itemKey' | 'icon' | 'badge' | 'metadata' | 'severity' | 'aria-controls' | 'labelMaxWidth'
  >;
/**
 * TabBarLinkItem is used to render links in a TabBar. It allows to view the browser's built in link context menu to open the link in new browser tab.
 */
export function TabBarLinkItem<K extends string | number>({
  itemKey,
  icon,
  badge,
  metadata,
  severity,
  labelMaxWidth,
  href,
  label,
  'aria-controls': ariaControls
}: TabBarLinkItemProps<K>) {
  return (
    <BaseTabBarItem
      aria-controls={ariaControls}
      itemKey={itemKey}
      label={label}
      icon={icon}
      badge={badge}
      metadata={metadata}
      severity={severity}
      labelMaxWidth={labelMaxWidth}
      href={href}></BaseTabBarItem>
  );
}
